import {Injectable} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';

@Injectable()
export class UtilsService {

    constructor() {
    }

    isVowel(word:String):boolean {
        return ['a', 'e', 'i', 'o', 'u'].indexOf(word.toLowerCase()[0]) !== -1;
    }

    decodeHtml(encodedString) {
        const textArea = document.createElement('textarea');
        textArea.innerHTML = encodedString;
        const unescapeValue = textArea.value;
        return unescapeValue;
    }

    validateAllFormFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsDirty({onlySelf: true});
            } else if (control instanceof FormGroup) {
                this.validateAllFormFields(control);
            }
        });
    }

    updateChartAreaFromData(barCharData, options){
        const canvas = document.createElement('canvas');
        let context = canvas.getContext("2d");
        context.font = "14px Arial";

        let maxWidth = 0;
        for (let i = 1; i < barCharData.length; i++) {
            const str = barCharData[i][0];
            const metrics = context.measureText(str);
            maxWidth = Math.max(maxWidth, metrics.width);
            // console.log(str + ':' + metrics.width);
        }
        const relSize = (maxWidth * 100 / 800) + 1; //800px is area width, we may want to calculate it
        options.chartArea.left = relSize + '%';
        options.chartArea.width = (85 - relSize) + '%'; //Leave 15% to Legend
    }

    durationTableSorterFactory(columnName){
        return function (row) {
            let value = row[columnName];
            return value ? +value.replace(':', '.') : -1;
        }
    }

    numberStringTableSorterFactory(columnName){
        return function (row) {
            const value = row[columnName];
            return !value ? 0 : +value;
        }
    }
}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/services/utils.service.ts